const friedewalds = function (cholesterol, hdl, triglycerides) {
  const correctionFactor = 0.45
  const c = parseFloat(cholesterol)
  const h = parseFloat(hdl)
  const t = parseFloat(triglycerides)
  if (isNaN(c) || isNaN(h) || isNaN(t)) {
    return ''
  }
  const ldl = c - h - (correctionFactor * t)
  return ldl.toFixed(2)
}

export {
  friedewalds
}



// WEBPACK FOOTER //
// ./src/plugins/friedewalds.js